import * as dayjs from "dayjs";
// Configuration file for scenario result dashboard page
// Chart.js Plot config for overall trend plot
export const overallTrendOptions = (plotQueryProps) => {
    return {
        responsive: true,
        elements: {
            point: {
                radius: 1
            }
        },
        plugins: {
            legend: {
                position: "right" as const,
            },
            title: {
                display: true,
                text: "Overall trend between baseline and scenario",
                font: {
                    size: 20
                },
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function (value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = dayjs(this.getLabelForValue(value), "DD/MM/YYYY").month()

                        if (label == 0) {
                            // For each month of the year we get a callback. This check will  only plot the single month per year
                            // @ts-ignore
                            return dayjs(this.getLabelForValue(value)).format("YYYY")
                        }
                    }
                },
                grid: {
                    display: false,
                    drawTicks: false,
                }
            },
            y: {
                ticks: {
                    maxTicksLimit: 5,
                    callback: function (value) {
                        return (plotQueryProps.unit === 'value' ? '' : '$') + (value / 1000000).toLocaleString() + "M";
                        // The .toLocaleString() method adds a comma separator for thousands.
                    }
                },
            }
        }
    }
}


//Configuration list for all the plot filters
export const filterConfigList = [
    {
        name: "State", //Display name of the filter
        propID: "inState", //Filter prop name for the graphql endpoint
        listName: "executeGetState", // List name of filter options from API response
        valueKey: "State", // Key name of the filter option
        valueName: "State", // Value name of the filter option
        multiple: true,
        defaultValue: "ALL" //default value to be used for the filter
    },
    {
        name: "Location",
        propID: "inLocationID",
        listName: "executeGetLocationList",
        valueKey: "LocationID",
        valueName: "LocationName",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Source",
        propID: "inSource",
        listName: "executeGetSourceList",
        valueKey: "Source",
        valueName: "Source",
        defaultValue: "ALL"
    },
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "Infra-flag",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    },
];
